// Топологія СЕС «Лучки» — конфіг станції для однолінійної схеми.
//
// ЗГЕНЕРОВАНО без змін із luchky_topology.json (пакет ТЗ SLD, 21.10.2026), який
// своєю чергою зібрано з таблиці адресації Strabichovo_equipment_addressing.xlsx
// і «ТЗ для EMS box» ред. 3.1, § 2. Не редагувати вручну: замінити JSON і
// перегенерувати. Схема (StationSld) будується з цих даних, нічого з топології
// не захардкоджено в розмітці.
import type { StationTopology } from "./sldTypes";

export const LUCHKY_TOPOLOGY: StationTopology = {
  "station": "СЕС Лучки (ТОВ «ЕЛІОС ЛУЧКИ», с. Страбичово)",
  "source": "sources/Strabichovo_equipment_addressing.xlsx + sources/TZ_EMS_box_v3.1.docx §2",
  "sign_convention": "P_PCC: + експорт у мережу, − імпорт; P_BESS/PCS: + розряд, − заряд",
  "pcc": {
    "device": "Socomec DIRIS A-30",
    "ip": "192.168.37.27",
    "port": 9761,
    "slave_id": 5
  },
  "ems_box": {
    "ip": "192.168.37.238"
  },
  "bess": [
    {
      "pos": "УЗЕ-1",
      "note": "ВІДПОВІДНІСТЬ УЗЕ-N ↔ BCS #N ПЕРЕВІРИТИ ЗА ОДНОЛІНІЙНОЮ СХЕМОЮ",
      "system": "BCS4000K-C-HUD",
      "bcs": "BCS #1",
      "sn": "6152602021R0816K00002",
      "banks": [
        {
          "pos": "1.GB",
          "model": "JKE-4597K-2H-LAA",
          "sn": "25BS903711",
          "scu_ip": "192.168.37.51",
          "racks": 11,
          "pcs": [
            {
              "pos": "T1.1",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00009",
              "ip": "192.168.37.61",
              "racks": "1–6",
              "rack_group": "A"
            },
            {
              "pos": "T1.2",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00010",
              "ip": "192.168.37.62",
              "racks": "7–11",
              "rack_group": "B"
            }
          ]
        },
        {
          "pos": "2.GB",
          "model": "JKE-4597K-2H-LAA",
          "sn": "25BS903710",
          "scu_ip": "192.168.37.52",
          "racks": 11,
          "pcs": [
            {
              "pos": "T1.3",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00015",
              "ip": "192.168.37.63",
              "racks": "1–6",
              "rack_group": "A"
            },
            {
              "pos": "T1.4",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00008",
              "ip": "192.168.37.64",
              "racks": "7–11",
              "rack_group": "B"
            }
          ]
        }
      ]
    },
    {
      "pos": "УЗЕ-2",
      "note": "ВІДПОВІДНІСТЬ УЗЕ-N ↔ BCS #N ПЕРЕВІРИТИ ЗА ОДНОЛІНІЙНОЮ СХЕМОЮ",
      "system": "BCS4000K-C-HUD",
      "bcs": "BCS #2",
      "sn": "6152602021R0816K00003",
      "banks": [
        {
          "pos": "3.GB",
          "model": "JKE-4597K-2H-LAA",
          "sn": "25BS903705",
          "scu_ip": "192.168.37.53",
          "racks": 11,
          "pcs": [
            {
              "pos": "T2.1",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00005",
              "ip": "192.168.37.65",
              "racks": "1–6",
              "rack_group": "A"
            },
            {
              "pos": "T2.2",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00002",
              "ip": "192.168.37.66",
              "racks": "7–11",
              "rack_group": "B"
            }
          ]
        },
        {
          "pos": "4.GB",
          "model": "JKE-4597K-2H-LAA",
          "sn": "25BS903704",
          "scu_ip": "192.168.37.54",
          "racks": 11,
          "pcs": [
            {
              "pos": "T2.3",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00007",
              "ip": "192.168.37.67",
              "racks": "1–6",
              "rack_group": "A"
            },
            {
              "pos": "T2.4",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00016",
              "ip": "192.168.37.68",
              "racks": "7–11",
              "rack_group": "B"
            }
          ]
        }
      ]
    },
    {
      "pos": "УЗЕ-3",
      "note": "ВІДПОВІДНІСТЬ УЗЕ-N ↔ BCS #N ПЕРЕВІРИТИ ЗА ОДНОЛІНІЙНОЮ СХЕМОЮ",
      "system": "BCS4000K-C-HUD",
      "bcs": "BCS #3",
      "sn": "6152602021R0816K00004",
      "banks": [
        {
          "pos": "6.GB",
          "model": "JKE-4597K-2H-LAA",
          "sn": "25BS903706",
          "scu_ip": "192.168.37.56",
          "racks": 11,
          "pcs": [
            {
              "pos": "T3.1",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00013",
              "ip": "192.168.37.69",
              "racks": "1–6",
              "rack_group": "A"
            },
            {
              "pos": "T3.2",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00006",
              "ip": "192.168.37.70",
              "racks": "7–11",
              "rack_group": "B"
            }
          ]
        },
        {
          "pos": "5.GB",
          "model": "JKE-4597K-2H-LAA",
          "sn": "25BS903707",
          "scu_ip": "192.168.37.55",
          "racks": 11,
          "pcs": [
            {
              "pos": "T3.3",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00011",
              "ip": "192.168.37.71",
              "racks": "1–6",
              "rack_group": "A"
            },
            {
              "pos": "T3.4",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00012",
              "ip": "192.168.37.72",
              "racks": "7–11",
              "rack_group": "B"
            }
          ]
        }
      ]
    },
    {
      "pos": "УЗЕ-4",
      "note": "ВІДПОВІДНІСТЬ УЗЕ-N ↔ BCS #N ПЕРЕВІРИТИ ЗА ОДНОЛІНІЙНОЮ СХЕМОЮ",
      "system": "BCS4000K-C-HUD",
      "bcs": "BCS #4",
      "sn": "6152602021R0816K00001",
      "banks": [
        {
          "pos": "8.GB",
          "model": "JKE-4597K-2H-LAA",
          "sn": "25BS903708",
          "scu_ip": "192.168.37.58",
          "racks": 11,
          "pcs": [
            {
              "pos": "T4.1",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00001",
              "ip": "192.168.37.73",
              "racks": "1–6",
              "rack_group": "A"
            },
            {
              "pos": "T4.2",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00014",
              "ip": "192.168.37.74",
              "racks": "7–11",
              "rack_group": "B"
            }
          ]
        },
        {
          "pos": "7.GB",
          "model": "JKE-4597K-2H-LAA",
          "sn": "25BS903709",
          "scu_ip": "192.168.37.57",
          "racks": 11,
          "pcs": [
            {
              "pos": "T4.3",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00003",
              "ip": "192.168.37.75",
              "racks": "1–6",
              "rack_group": "A"
            },
            {
              "pos": "T4.4",
              "model": "BCS1000K-C-HUD",
              "sn": "501523027760R9A00004",
              "ip": "192.168.37.76",
              "racks": "7–11",
              "rack_group": "B"
            }
          ]
        }
      ]
    }
  ],
  "pv": [
    {
      "pos": "КТП-1",
      "transformer": "T5",
      "ezlogger": {
        "sn": "93000SCA25AH0019",
        "ip": "192.168.37.241",
        "port": 502
      },
      "inverter_count": 20,
      "groups": [
        {
          "group": "D1",
          "channel": "CAN-CCO",
          "plc": "PLC Transformer No. 10",
          "inverters": [
            {
              "pos": "11.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0086",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF10",
              "logger_ip": "192.168.37.241",
              "unit_id": 111,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "12.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0070",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF9",
              "logger_ip": "192.168.37.241",
              "unit_id": 112,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "13.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0055",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF8",
              "logger_ip": "192.168.37.241",
              "unit_id": 113,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "14.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0056",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF7",
              "logger_ip": "192.168.37.241",
              "unit_id": 114,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "15.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0068",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF6",
              "logger_ip": "192.168.37.241",
              "unit_id": 115,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "16.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0080",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF5",
              "logger_ip": "192.168.37.241",
              "unit_id": 116,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "17.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0084",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF4",
              "logger_ip": "192.168.37.241",
              "unit_id": 117,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "18.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0085",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF3",
              "logger_ip": "192.168.37.241",
              "unit_id": 118,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "19.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0026",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF2",
              "logger_ip": "192.168.37.241",
              "unit_id": 119,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "20.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0041",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D1",
              "breaker": "1.QF1",
              "logger_ip": "192.168.37.241",
              "unit_id": 120,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            }
          ]
        },
        {
          "group": "D2",
          "channel": "MAIN-CCO",
          "plc": "PLC Transformer No. 20",
          "inverters": [
            {
              "pos": "1.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0097",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF10",
              "logger_ip": "192.168.37.241",
              "unit_id": 201,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "2.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0098",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF9",
              "logger_ip": "192.168.37.241",
              "unit_id": 202,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "3.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0077",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF8",
              "logger_ip": "192.168.37.241",
              "unit_id": 203,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "4.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0072",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF7",
              "logger_ip": "192.168.37.241",
              "unit_id": 204,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "5.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0087",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF6",
              "logger_ip": "192.168.37.241",
              "unit_id": 205,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "6.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0028",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF1",
              "logger_ip": "192.168.37.241",
              "unit_id": 206,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "7.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0043",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF2",
              "logger_ip": "192.168.37.241",
              "unit_id": 207,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "8.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0075",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF3",
              "logger_ip": "192.168.37.241",
              "unit_id": 208,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "9.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0061",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF4",
              "logger_ip": "192.168.37.241",
              "unit_id": 209,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "10.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0078",
              "ktp": "КТП-1",
              "transformer": "T5",
              "group": "D2",
              "breaker": "2.QF5",
              "logger_ip": "192.168.37.241",
              "unit_id": 210,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            }
          ]
        }
      ]
    },
    {
      "pos": "КТП-2",
      "transformer": "T6",
      "ezlogger": {
        "sn": "93000SCA25BH0001",
        "ip": "192.168.37.242",
        "port": 502
      },
      "inverter_count": 24,
      "groups": [
        {
          "group": "D1",
          "channel": "CAN-CCO",
          "plc": "PLC Transformer No. 10",
          "inverters": [
            {
              "pos": "33.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0033",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF6",
              "logger_ip": "192.168.37.242",
              "unit_id": 133,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "34.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0034",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF5",
              "logger_ip": "192.168.37.242",
              "unit_id": 134,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "35.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0052",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF4",
              "logger_ip": "192.168.37.242",
              "unit_id": 135,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "36.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0027",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF3",
              "logger_ip": "192.168.37.242",
              "unit_id": 136,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "37.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0045",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF2",
              "logger_ip": "192.168.37.242",
              "unit_id": 137,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "38.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0022",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF1",
              "logger_ip": "192.168.37.242",
              "unit_id": 138,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "39.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0069",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF9",
              "logger_ip": "192.168.37.242",
              "unit_id": 139,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "40.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0073",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF10",
              "logger_ip": "192.168.37.242",
              "unit_id": 140,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "41.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0040",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF11",
              "logger_ip": "192.168.37.242",
              "unit_id": 141,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "42.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0039",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF12",
              "logger_ip": "192.168.37.242",
              "unit_id": 142,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "43.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0058",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF13",
              "logger_ip": "192.168.37.242",
              "unit_id": 143,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "44.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0059",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D1",
              "breaker": "1.QF14",
              "logger_ip": "192.168.37.242",
              "unit_id": 144,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            }
          ]
        },
        {
          "group": "D2",
          "channel": "MAIN-CCO",
          "plc": "PLC Transformer No. 20",
          "inverters": [
            {
              "pos": "21.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0037",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF14",
              "logger_ip": "192.168.37.242",
              "unit_id": 221,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "22.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0038",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF13",
              "logger_ip": "192.168.37.242",
              "unit_id": 222,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "23.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0029",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF12",
              "logger_ip": "192.168.37.242",
              "unit_id": 223,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "24.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0089",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF11",
              "logger_ip": "192.168.37.242",
              "unit_id": 224,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "25.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0042",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF10",
              "logger_ip": "192.168.37.242",
              "unit_id": 225,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "26.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0091",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF9",
              "logger_ip": "192.168.37.242",
              "unit_id": 226,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "27.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0081",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF6",
              "logger_ip": "192.168.37.242",
              "unit_id": 227,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "28.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0088",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF5",
              "logger_ip": "192.168.37.242",
              "unit_id": 228,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "29.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0082",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF4",
              "logger_ip": "192.168.37.242",
              "unit_id": 229,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "30.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0100",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF3",
              "logger_ip": "192.168.37.242",
              "unit_id": 230,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "31.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0074",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF2",
              "logger_ip": "192.168.37.242",
              "unit_id": 231,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "32.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0076",
              "ktp": "КТП-2",
              "transformer": "T6",
              "group": "D2",
              "breaker": "2.QF1",
              "logger_ip": "192.168.37.242",
              "unit_id": 232,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            }
          ]
        }
      ]
    },
    {
      "pos": "КТП-3",
      "transformer": "T7",
      "ezlogger": {
        "sn": "93000SCA25BH0002",
        "ip": "192.168.37.240",
        "port": 502
      },
      "inverter_count": 20,
      "groups": [
        {
          "group": "D1",
          "channel": "CAN-CCO",
          "plc": "PLC Transformer No. 10",
          "inverters": [
            {
              "pos": "55.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0067",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF1",
              "logger_ip": "192.168.37.240",
              "unit_id": 155,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "56.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0031",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF2",
              "logger_ip": "192.168.37.240",
              "unit_id": 156,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "57.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0021",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF3",
              "logger_ip": "192.168.37.240",
              "unit_id": 157,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "58.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0071",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF4",
              "logger_ip": "192.168.37.240",
              "unit_id": 158,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "59.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0066",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF5",
              "logger_ip": "192.168.37.240",
              "unit_id": 159,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "60.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0094",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF10",
              "logger_ip": "192.168.37.240",
              "unit_id": 160,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "61.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0093",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF9",
              "logger_ip": "192.168.37.240",
              "unit_id": 161,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "62.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0090",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF8",
              "logger_ip": "192.168.37.240",
              "unit_id": 162,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "63.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0092",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF7",
              "logger_ip": "192.168.37.240",
              "unit_id": 163,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            },
            {
              "pos": "64.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0063",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D1",
              "breaker": "1.QF6",
              "logger_ip": "192.168.37.240",
              "unit_id": 164,
              "channel": "CAN-CCO",
              "plc": "PLC Transformer No. 10"
            }
          ]
        },
        {
          "group": "D2",
          "channel": "MAIN-CCO",
          "plc": "PLC Transformer No. 20",
          "inverters": [
            {
              "pos": "45.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0083",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF6",
              "logger_ip": "192.168.37.240",
              "unit_id": 45,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "46.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0099",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF7",
              "logger_ip": "192.168.37.240",
              "unit_id": 46,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "47.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0095",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF8",
              "logger_ip": "192.168.37.240",
              "unit_id": 47,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "48.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0096",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF9",
              "logger_ip": "192.168.37.240",
              "unit_id": 48,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "49.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0065",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF10",
              "logger_ip": "192.168.37.240",
              "unit_id": 49,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "50.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0023",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF1",
              "logger_ip": "192.168.37.240",
              "unit_id": 50,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "51.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0024",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF2",
              "logger_ip": "192.168.37.240",
              "unit_id": 51,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "52.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0062",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF3",
              "logger_ip": "192.168.37.240",
              "unit_id": 52,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "53.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0064",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF4",
              "logger_ip": "192.168.37.240",
              "unit_id": 53,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            },
            {
              "pos": "54.U",
              "model": "GW250K-HT",
              "sn": "5250KHTU258H0079",
              "ktp": "КТП-3",
              "transformer": "T7",
              "group": "D2",
              "breaker": "2.QF5",
              "logger_ip": "192.168.37.240",
              "unit_id": 54,
              "channel": "MAIN-CCO",
              "plc": "PLC Transformer No. 20"
            }
          ]
        }
      ]
    }
  ]
};
